function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "video_camera"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m21.493 6.13c-.313-.178-.698-.173-1.007.013l-3.486 2.09v-.233c0-1.103-.897-2-2-2h-11c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2v-.233l3.485 2.091c.159.094.337.142.515.142.17 0 .34-.043.493-.13.313-.178.507-.51.507-.87v-10c0-.36-.194-.692-.507-.87zm-1.493 9.103-3.485-2.091c-.31-.186-.694-.19-1.007-.013s-.508.511-.508.871v2h-11v-8h11v2c0 .36.194.692.507.87s.698.173 1.007-.013l3.486-2.09z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 9h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
})));

var Svg127VideoCamera = function Svg127VideoCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg127VideoCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/127-video-camera.6b7bf1fd.svg";
export { ForwardRef as ReactComponent };